import React, {useState} from 'react'
import {DataObjectId} from 'yougile-model'
import {DropdownMenuContainer} from '@components/common/base/dropdown-button-menu/dropdown-menu-container'
import {DropdownMenuItem} from '@components/common/base/dropdown-button-menu/dropdown-menu-item'
import {Select} from '@components/common/base/select'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'
import {cn} from '@containers/html-utils'
import {TippyProps} from '@tippyjs/react'
import {OptionsItem} from '../dropdown-button-menu/types'

export interface SelectWithDropdownProps<T = string> {
  options?: OptionsItem<T>[]
  value: string | DataObjectId | undefined
  withIcons?: boolean
  withNumbers?: boolean
  placeholder?: string
  size?: '28' | '32' | '36' | '40'
  disabled?: boolean
  allCaption?: string
  width?: string
  onChange?: (value: OptionsItem<T>) => void
  variant?: 'default' | 'panel' | 'new'
  link?: boolean
  error?: boolean
  className?: string
  bgColor?: string
  content?: React.ReactNode
  innerClassName?: string
  placement?: TippyProps['placement']
  icon?: TablerIcons
}

export const SelectWithDropdown = <T,>(props: SelectWithDropdownProps<T>) => {
  const {
    options,
    withIcons,
    withNumbers,
    size = '32',
    className,
    bgColor,
    content,
    onChange,
    placeholder,
    variant = 'default',
    error = false,
    link,
    innerClassName,
    placement,
    icon
  } = props

  const [open, setOpen] = useState(false)

  let value = props.value
  if (!value && !placeholder) {
    value = options?.[0]?.text || ''
  }

  return (
    <Select
      icon={icon}
      content={
        content || (
          <DropdownMenuContainer
            onClick={() => {
              setOpen(false)
            }}
            className={cn(props.width, innerClassName)}
          >
            {options?.map(item => (
              <DropdownMenuItem
                key={item.text}
                item={item}
                withIcons={withIcons}
                withNumbers={withNumbers}
                size={size}
                onChange={onChange}
              />
            ))}
          </DropdownMenuContainer>
        )
      }
      open={open}
      onOpenChange={v => setOpen(v)}
      placeholder={placeholder}
      disabled={props.disabled}
      variant={variant}
      link={link}
      error={error}
      className={className}
      bgColor={bgColor}
      placement={placement}
    >
      {value}
    </Select>
  )
}
